import { Subject } from 'rxjs'
import { postFormData } from '../util'
import { modalController } from '../ui'
import loadingButton from '../ui/loadingButton'

const Controller = {
    el: null,
    inputs: [],
    errorMessageEl: null,

    inputKeys: [],
    isFormDirty: false,
    action: '',

    onErrorEvent: null,
    onSucccessEvent: null,

    onError: null,
    onSucccess: null,

    init,
    resetForm
}

export function createController(selector, onSucccess, onError) {
    const Obj = Object.create(Controller)
    Obj.init(selector, onSucccess, onError)
    return Obj
}

function init(selector, onSucccess, onError) {
    if (typeof selector === 'string') {
        this.el = document.querySelector(selector)
    } else {
        this.el = selector
    }

    if (!this.el) {
        return
    }

    this.errorMessageEl = this.el.querySelector('.js-form-errors')
    this.inputs = this.el.querySelectorAll('[name]')
    this.inputs = Array.from(this.inputs)
    this.inputs = this.inputs.reduce((acc, input) => {
        const name = input.name.replace(/\[\]/, '')
        if (acc[name]) {
            return acc
        }

        acc[name] = input
        return acc
    }, {})

    this.inputKeys = Object.keys(this.inputs).map((el) => el.replace(/\[\]/, ''))
    this.action = this.el.action

    this.onErrorEvent = new Subject()
    this.onSucccessEvent = new Subject()

    this.onError = onError || handleError
    this.onSucccess = onSucccess || handleReturn
    this.onError = this.onError.bind(this)
    this.onSucccess = this.onSucccess.bind(this)
    this.resetForm = this.resetForm.bind(this)

    this.onErrorEvent.subscribe(this.onError)
    this.onSucccessEvent.subscribe(this.onSucccess)

    this.loadingButton = loadingButton(this.el.querySelector('.u-btn'))

    this.el.addEventListener('submit', handleSubmit.bind(this))

    resetForm.call(this)
}

function handleSubmit(evt) {
    evt.preventDefault()
    this.loadingButton.startLoading()
    const formData = new FormData(this.el)

    if (this.el.classList.contains('processing')) {
        return
    }

    this.el.classList.add('processing')

    postFormData(this.action, formData)
        .then((data) => JSON.parse(data))
        .then((data) => {
            this.onSucccessEvent.next({ data, formData })
        })
        .catch((data) => {
            if (!data) {
                data = {
                    success: false,
                    message: 'Failed to connect to the server, please check you are online',
                    data: {}
                }
            } else {
                data = JSON.parse(data)
            }
            this.onSucccessEvent.next({ data, formData })
        })
        .finally(() => {
            this.loadingButton.stopLoading()
            this.el.classList.remove('processing')
        })
}

// function handleSubmit(evt) {
//     evt.preventDefault()

//     const formData = new FormData(this.el)

//     // post(this.action, formData)
//     //     .then(data => JSON.parse(data))
//     //     .then(data => {
//     //         this.onSucccessEvent.next({ data, formData })
//     //     })
//     //     .catch(err => {
//     //         this.onErrorEvent.next(err)
//     //     })

//     const testSuccessData = {
//         success: true,
//         message:
//             'Duis odio est maximus id elementum quisndimentum et torrabitur dignissim non diam aliqueed aliquam elit vitae volutpat auctor. ',
//         data: []
//     }
//     this.onSucccessEvent.next({ data: testSuccessData, formData })

//     // const testErrorData = {
//     //     success: false,
//     //     message: 'you done fucked up',
//     //     data: {
//     //         name: 'First name is required',
//     //         email: 'Email address is required',
//     //         company: 'company is required',
//     //         tel: 'Phone number is required',
//     //         message: 'Message is required'
//     //     }
//     // }
//     // this.onSucccessEvent.next({ data: testErrorData, formData })
// }

export function handleReturn({ data }, includeTracking = true) {
    if (!data) {
        return
    }

    resetForm.call(this)

    if (data.trackingEvent && typeof ga === 'function' && includeTracking) {
        const trackers = ga.getAll()
        if (trackers.length) {
            const trackerName = trackers[0].get('name')
            ga(trackerName + '.send', 'event', data.trackingEvent)
        }
    }

    if (data.success) {
        if (data.redirect) {
            window.location.href = data.redirect
            return
        }

        let message = `<p>Thank you</p>`
        if (data.message) {
            message = `<p>${data.message}</p>`
        }

        modalController.addModal({
            id: 'ThankYou',
            content: message + `<button class="u-btn js-modal-close">Close window</button>`,
            icon: 'logo',
            header: 'Thank You'
        })
        modalController.openModal('ThankYou')
        clearForm.call(this)
        return
    }

    const errorKeys = Object.keys(data.data)

    if (data.message) {
        let html = ''
        if (data.accessibleMessage) {
            html += `<h3 class="u-visually-hidden">${data.accessibleMessage}</h3>`
        }
        if (data.message) {
            html += `<p aria-hidden="true"><strong>${data.message}</strong></p>`
        }
        if (errorKeys.length) {
            html += '<ul data-unstyled>'
            for (let i = 0; i < errorKeys.length; i++) {
                let errorMessage = data.data[errorKeys[i]]['detailedMessage']
                if (errorMessage) {
                    html += `<li><p><a href="#${errorKeys[i]}" class="u-btn" data-arrow="down" data-color="grey">${errorMessage}</a></p></li>`
                }
            }
            html += '</ul>'
        }

        this.errorMessageEl.innerHTML = html
        this.errorMessageEl.dataset.active = true
        this.errorMessageEl.setAttribute('role', 'alert')
    }

    errorKeys.forEach((key) => {
        if (!~this.inputKeys.indexOf(key)) {
            return
        }

        const el = this.inputs[key]
        const formGroupEl = el.closest('.u-form__group')
        if (!formGroupEl) {
            return
        }

        const label = formGroupEl.querySelector('label')
        label.setAttribute('aria-label', 'Error: ' + label.innerText)

        const div = document.createElement('div')
        div.classList.add('u-form__message')
        div.id = key + '_error'
        div.innerHTML = `<p>${data.data[key]['message']}</p>`

        el.setAttribute('aria-describedby', key + '_error')

        formGroupEl.appendChild(div)
        formGroupEl.dataset.error = true
    })
}

function handleError() {
    handleReturn.call({
        success: false,
        msg: 'There was an issue connecting to the server, please try again.',
        fields: {}
    })
}

export function resetForm() {
    this.isFormDirty = false
    this.errorMessageEl.removeAttribute('role')
    this.errorMessageEl.removeAttribute('data-active')
    this.errorMessageEl.innerHTML = ''
    this.inputKeys.forEach((key) => {
        const el = this.inputs[key]
        const formGroupEl = el.closest('.u-form__group')
        if (!formGroupEl) {
            return
        }

        const label = formGroupEl.querySelector('label')
        label.removeAttribute('aria-label')

        const message = formGroupEl.querySelector('.u-form__message')
        if (message) {
            message.remove()
        }

        el.removeAttribute('aria-describedby')
        formGroupEl.removeAttribute('data-error')
    })
}

function clearForm() {
    this.el.reset()
}
